import ApplePayPaymentContact = ApplePayJS.ApplePayPaymentContact;
import { RmsBookstoreAddress } from '../../../checkout/shop-checkout.interface';

/**
 * Maps an Apple Pay address to a checkout address.
 *
 * @param address
 * @param fallbackNumber
 */
export function mapAppleAddress(address?: ApplePayPaymentContact, fallbackNumber?: string): RmsBookstoreAddress {
  const addressLines = address?.addressLines ?? [];
  const phoneNumber = address?.phoneNumber || fallbackNumber;

  return {
    firstName: address?.givenName ?? '',
    lastName: address?.familyName ?? '',
    address1: addressLines[0] ?? '',
    address2: addressLines[1] ?? '',
    city: address?.locality ?? '',
    country: address?.countryCode ?? '',
    zipCode: address?.postalCode ?? '',
    state: address?.administrativeArea ?? '',
    phoneNumber: phoneNumber ?? '',
  };
}
